import { __awaiter } from "tslib";
import { showError } from '@/store';
import { alas, status } from '@/alas';
import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let route = context.root.$route;
        let router = context.root.$router;
        // ================
        //
        // refs
        //
        let cycle = ref(alas.make('farm', 'cycle').$init());
        let types = ref(status.fetch('types'));
        let validate = ref(false);
        // ================
        //
        // methods
        //
        let submit = () => __awaiter(this, void 0, void 0, function* () {
            try {
                let id = route.params.id;
                let createdAt = yield cycle.value.$o.create.start({
                    farmId: id
                });
                status.reset('cycles');
                router.push({
                    name: 'farms.cycles.overview',
                    params: {
                        id,
                        cycle: createdAt.toString()
                    }
                });
            }
            catch (error) {
                showError(error);
            }
        });
        // ================
        //
        // done
        //
        return {
            cycle,
            types,
            validate,
            submit
        };
    }
});
